import * as React from 'react'

import { cn } from '@/lib/utils'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type CardProps = React.ComponentProps<'div'> & {
  tooltipContent?: React.ReactNode
}

function Card({ className, tooltipContent, ...props }: CardProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          data-slot="card"
          className={cn(
            'bg-card text-card-foreground flex flex-col gap-6 border py-6',
            className
          )}
          {...props}
        />
      </TooltipTrigger>
      {tooltipContent && <TooltipContent>{tooltipContent}</TooltipContent>}
    </Tooltip>
  )
}

export { Card }
